import styled from 'styled-components';
const colors = require('common/lib/colors/colors.less');

import { Card } from './Card';

export const List = styled.div`
  background-color: ${colors.N40};
  border-radius: 3px;
  box-sizing: border-box;
  width: 40px;
  padding: 4px 4px 16px;

  ${Card} {
    margin-bottom: 4px;

    &:last-child {
      margin-bottom: 0;
    }
  }
`;



// WEBPACK FOOTER //
// ./app/common/components/canonical-components/canonical-board/List.js